//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { InvoiceStatus } from './Enums';

export class InvoiceStatusUpdateItem extends ItemBase {
    InvoiceID: string | null = null;
    Status: InvoiceStatus = InvoiceStatus.Void;

    constructor(initializer?: Partial<InvoiceStatusUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "InvoiceStatusUpdateItem";
}
